// 存物完成
<template>
  <div class="saveFinish back-index">
    <!-- 流程 -->
    <userSaveFlow :index="4" v-if="$store.state.type === 'staff'"></userSaveFlow>
    <expressSaveFlow :index="5" v-else></expressSaveFlow>
    <!-- {{box.showStatus != ''}}{{box.showStatus}} -->
    <div>
      <span
        class="status"
        :class="[box.showStatus ? 'success' : 'fail']"></span>
      <p
        class="info"
        v-if="box.showStatus">
        已经为您打开编号为：
        <span class="num">{{box.size}}-{{box.box_number}}号箱格</span>
      </p>
      <p :class="[box.showStatus ? 'des' : 'info']">{{box.showStatus ? '请存放物品并随手关门' : box.errorText}}</p>
      <!-- 再存一个 -->
      <p
        class="save-again"
        v-show="$store.state.type === 'express' && box.showStatus"
        @click="saveAgain">
        再存一个
      </p>
      <countDown :time="time" v-if="time !== ''"></countDown>
    </div>
  </div>
</template>

<script>
import userSaveFlow from '../userSave/userSaveFlow'
import expressSaveFlow from '../expressSave/expressSaveFlow'
import countDown from '../common/countDown'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showLoading, hideLoading, storage, clearCountDown } from '../../../../static/turnoverCabinet/js/utility'

export default {
  name: 'saveFinish',
  components: {
    userSaveFlow,
    expressSaveFlow,
    countDown
  },
  data () {
    return {
      time: '',
      box: {
        showStatus: '',
        errorText: ''
      }
    }
  },
  created () {
    console.log('type', this.$store.state.type)
    console.log('deliverData', this.$store.state.deliverData)
    this.deliver()
  },
  mounted () {
  },
  methods: {
    // 打开箱门，进行投件
    deliver: async function () {
      let vm = this
      let data = vm.$store.state.deliverData
      data.device_no_id = storage.localGetItem('device_no_id')
      console.log('投件data', data)

      showLoading('正在打开箱格')
      let res = await cabinetApi.deliver(data)
      console.log('res', res)
      hideLoading()
      if (res.meta.code === 200) {
        vm.box = res.data
        console.log('vm.box', vm.box)
        vm.box.showStatus = true
      } else {
        vm.box.showStatus = false
        vm.box.errorText = res.meta.message
      }
      this.time = this.$store.state.type === 'staff' ? 10 : 60
      console.log('vm.box', vm.box)
    },
    // 再存一个
    saveAgain: function () {
      clearCountDown()
      // 清空投递参数
      this.$store.state.deliverData.box_style = ''
      this.$store.state.deliverData.t_package_no = ''
      this.$store.state.deliverData.user_id = ''
      this.$router.push({
        // 你要跳转的地址
        path: '/turnoverCabinet/selectCell'
      })
    }
  }
}
</script>

<style scoped>
.saveFinish{
  width: 100%;
  text-align: center;
}

.saveFinish .status{
  display: block;
  width: 2rem;
  height: 2rem;
  margin: 0.8rem auto 0;
}

.saveFinish .status.success{
  background: url(/../static/turnoverCabinet/images/icon/success.png) center no-repeat;
  background-size: 100%;
}

.saveFinish .status.fail{
  background: url(/../static/turnoverCabinet/images/icon/fail.png) center no-repeat;
  background-size: 100%;
}

.saveFinish .info,
.saveFinish .des{ 
  font-size: 0.45rem;
  line-height: 0.85rem;
}

.saveFinish .info{
  margin-top: 0.45rem;
}

.saveFinish .hint{
  font-size: 15px;
  color: #ff0000;
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: auto;
}

.saveFinish .save-again{
  display: block;
  width: 4.56rem;
  margin: 0.5rem auto 0;
  height: 1.82rem;
  line-height: 1.82rem;
  text-align: center;
  border-radius: 0.1rem;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 0;
  background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
  background: linear-gradient(to top,#076abf, #4cacff);
  box-shadow: #2c4b64 0px 0px 0.2rem;
}

</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/common/saveFinish.vue